import { render } from "./FormWord.vue?vue&type=template&id=b10468c2&scoped=true&ts=true"
import script from "./FormWord.vue?vue&type=script&lang=ts"
export * from "./FormWord.vue?vue&type=script&lang=ts"

import "./FormWord.vue?vue&type=style&index=0&id=b10468c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10468c2"]])

export default __exports__